





  import { Vue, Component } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'

  const cms = namespace('cms')

  @Component
  export default class OneNoticeBanner extends Vue {
    @cms.Getter configuration: any

    get notice() {
      return this.configuration && this.configuration.notice
    }
  }
